export default __webpack_public_path__ + "static/media/youth-law-victoria.0a2188e0.png";